import {Component, Input} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap';
import {Device} from '../../models/device';

@Component({
    selector: 'app-device-modal',
    template: `
        <div class="modal-header">
            <h4 class="modal-title pull-left">{{title}}</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <br>
            <div class="container-form">
                <div class="input-group">
                    <label class="col-5">Device Name</label>
                    <select class="form-control col-7" [ngModel]="device.name" [disabled]="!editMode">
                        <option [value]="PHONE" [label]="PHONE"></option>
                        <option [value]="TABLET" [label]="TABLET"></option>
                    </select>
                </div>
                <div class="input-group">
                    <label class="col-5">Mac</label>
                    <input class="form-control col-7" placeholder="Mac"
                           [ngModel]="device.mac"
                           [disabled]="editMode"/>
                </div>
                <div class="input-group">
                    <label class="col-5">Device company</label>
                    <input class="form-control col-7" type="checkbox"
                           [ngModel]="device.isCompanyDevice"
                           [disabled]="editMode"/>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="bsModalRef.hide()" translate="cancel"></button>
            <ng-container *ngIf="editMode">
                <button type="button" class="btn btn-success" (click)="clickOk()" translate="save">Update</button>
            </ng-container>
            <ng-container *ngIf="!editMode">
                <button type="button" class="btn btn-success" (click)="clickOk()" translate="save">Register!</button>
            </ng-container>
        </div>`,
    providers: [BsModalService]
})

export class DeviceModalComponent {

    public PHONE = Device.PHONE;
    public TABLET = Device.TABLET;

    @Input() editMode: boolean;
    @Input() newRegister: boolean;
    @Input() title: string = '';
    @Input() message: string = '';

    public device: Device;


    constructor(public bsModalRef: BsModalRef) {
        this.editMode = false;
        this.editMode = false;
        this.device = new Device();
    }

    public setDevice(device: Device) {
        this.device = device;
    }

    public clickOk() {
        console.log('Click ok...');
    }
}



// WEBPACK FOOTER //
// ./src/app/modals/device-modal.ts